import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import {
  REGISTER_ROUTE,
  RECOVER_PASSWORD_ROUTE
} from '../../../router/ClientRoutes'
import { ErrorMessage } from '../../partials/form/ErrorMessage'
import { logIn } from './LoginActions'
import {
  Input,
  CustomButton,
  GradientButton,
  FormLabel,
  FormGroup,
  ButtonsGroup,
  CustomForm,
  primaryColor
} from '../../partials'
import validate from './LoginValidation'
import { Translate } from 'react-localize-redux'

const LoginWrapper = styled.div`
  display:flex;
  margin: auto 0;
  align-items:center;
  justify-content:center;
  padding: 32px 16px;
  
  @media only screen and (max-width: 640px){
    margin-top: 50px;
  }
  
  @media only screen and (max-height: 615px) {
    height: 300px;
    padding-bottom: 10px;
  }
`

const RememberGroup = styled.div`
  display:flex;
  flex:1;
  align-items:center;
  margin-bottom:40px;
  margin-top:40px;
  font-family:Opensans;
  
  @media only screen and (max-width: 420px) {
    justify-content: center;
  }
`

export class Login extends React.Component {
  onSubmit = (values) => { //eslint-disable-line
    this.props.logIn({ username: values.email, password: values.password })
  }

  render () {
    const { error, handleSubmit, submitting } = this.props
    return (
      <Translate>{({ translate }) =>
        <LoginWrapper>
          <CustomForm onSubmit={handleSubmit(this.onSubmit)}>
            <FormGroup>
              <FormLabel>{translate('email')}</FormLabel>
              <Field name='email' auth component={Input}/>
            </FormGroup>

            <FormGroup>
              <FormLabel>{translate('password')}</FormLabel>
              <Field name='password' auth component={Input} type='password'/>
            </FormGroup>
            <ErrorMessage serverError={error} touched
                          style={{ alignSelf: 'center', marginTop: 20, position: 'inherit' }}>{error}</ErrorMessage>
            <RememberGroup>
              <Link style={{ textDecoration: 'none' }} to={RECOVER_PASSWORD_ROUTE}>
                <p style={{ color: primaryColor, fontSize: 15 }}>{translate('recover')}</p>
              </Link>
            </RememberGroup>
            <ButtonsGroup>
              <GradientButton width={250} type='submit' disabled={submitting}
                              style={{ flex: 2 }}>{translate('loginButton')}</GradientButton>
              <Link to={REGISTER_ROUTE}><CustomButton>{translate('registerButton')}</CustomButton></Link>

            </ButtonsGroup>

          </CustomForm>
        </LoginWrapper>}
      </Translate>
    )
  }
}

Login.propTypes = {
  logIn: PropTypes.func,
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool
}

Login = connect((state) => ({ error: state.login.error }), { logIn })(Login) //eslint-disable-line
export default reduxForm({
  form: 'loginForm',
  validate
})(Login)
